var React = require('react');

function TriangleInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.9805 21.75L0.980471 0.749997L30.9805 0.75L15.9805 21.75Z","fill":"#1864AB"}));
}

TriangleInline.defaultProps = {"width":"31","height":"22","viewBox":"0 0 31 22","fill":"none"};

module.exports = TriangleInline;

TriangleInline.default = TriangleInline;
